export const STU_NAME = '王大明';
export const STU_ID = '108000001';